import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { MultiSportRowItemProps } from '.'

const BasicRowItem: FunctionComponent<
    MultiSportRowItemProps & { marginX: number | number[] | string }
> = ({ display, children, width, marginX }) => (
    <Grid display={display} marginX={marginX} noExpand center minWidth={width} width={width}>
        {children}
    </Grid>
)

export default BasicRowItem
